import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "vinci_cookie_consent";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => { if (!localStorage.getItem(KEY)) setShow(true); }, 900);
    return () => clearTimeout(t);
  }, []);
  const decide = (v) => { localStorage.setItem(KEY, v); setShow(false); };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[70] rounded-sm border border-white/15 bg-[#0b0b0b]/95 backdrop-blur-xl p-6 shadow-2xl"
        >
          <div className="flex items-start gap-3">
            <Cookie size={20} className="text-[#B87333] shrink-0 mt-0.5" />
            <div>
              <p className="font-body text-sm text-[#C9C9C2] leading-relaxed">
                We use essential cookies to keep you signed in and to operate the store. See our{" "}
                <Link to="/privacy" className="text-[#B87333] hover:underline">Privacy Policy</Link> for details.
              </p>
              <div className="flex gap-3 mt-4">
                <button data-testid="cookie-accept" onClick={() => decide("accepted")} className="rounded-full bg-[#F5F5F0] text-black px-5 py-2.5 font-grotesk text-[10px] uppercase tracking-[0.2em] hover:bg-[#B87333] transition-colors">Accept</button>
                <button data-testid="cookie-decline" onClick={() => decide("essential")} className="rounded-full border border-white/20 px-5 py-2.5 font-grotesk text-[10px] uppercase tracking-[0.2em] text-[#C9C9C2] hover:border-[#B87333] transition-colors">Essential only</button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
